import { RootState } from '../../store';
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiVRR from '../../../libs/axios/apis';
import END_POINTS from '../../../services/endpoints';
import { notify } from '../../app/appSlice';
import { TCreativeImportVideo, TPreview } from './types';

export const previewAction = createAsyncThunk(
  'creativeImportVideo/peviewAction',
  async (videoUrls: string[], { getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;

    const response = await apiVRR('v2').get(
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.IMPORT(
        currentBrandId.toString()
      ),
      {
        params: { url_videos: videoUrls }
      }
    );

    return response.data;
  }
);

export const importAction = createAsyncThunk(
  'importVideo/importAction',
  async (params: { videos: TPreview[] }, { dispatch, getState }) => {
    const currentState = getState() as any;
    const currentBrandId =
      currentState.setting.vrr_preferences.current_brand_id;

    const response = await apiVRR('v2').post(
      END_POINTS.CREATIVE_ANALYTICS.CREATIVE_GALLERY.IMPORT(
        currentBrandId.toString()
      ),
      {
        videos: params.videos
      }
    );

    if (response.status >= 200) {
      dispatch(notify({ type: 'success' }));
    }

    return response.data;
  }
);

export const getVideoErrors = (
  state: RootState
): TCreativeImportVideo['errors'] | undefined =>
  state.creativeImportVideo.errors;

export const getPreviews = (
  state: RootState
): TCreativeImportVideo['previews'] | undefined =>
  state.creativeImportVideo.previews;

export const getIsComplete = (
  state: RootState
): TCreativeImportVideo['isComplete'] => state.creativeImportVideo.isComplete;
